import { OktaAuth } from '@okta/okta-auth-js'
import { useEffect, useState } from 'react'
import { getSubdomain } from '~/utilities/utils'
import { useSSOConfigQuery } from '~/graphql/hooks/useSSOConfig'
import { storage } from '~/utilities/storageUitls'

export const useOktaLogin = () => {
  const [oktaAuth, setOktaAuth] = useState<OktaAuth | null>(null)
  const [loading, setLoading] = useState(true)

  const subdomain = getSubdomain()

  const { ssoConfig, loading: loadingSSOConfig } = useSSOConfigQuery(subdomain)

  useEffect(() => {
    if (!ssoConfig || !subdomain) return

    const okta = new OktaAuth({
      clientId: ssoConfig.clientId,
      issuer: ssoConfig.issuer,
      redirectUri: ssoConfig.redirectUri,
      scopes: ['openid', 'email', 'profile'],
      pkce: true
    })

    storage.set('okta-auth-subdomain', subdomain)

    setOktaAuth(okta)
  }, [ssoConfig, subdomain])

  useEffect(() => {
    if (loadingSSOConfig) return
    if (!ssoConfig) {
      setLoading(false)
      return
    }
    if (oktaAuth) return setLoading(false)

    setLoading(false)
  }, [loadingSSOConfig, ssoConfig, oktaAuth])

  return {
    oktaAuth,
    loading
  }
}
